import { render, staticRenderFns } from "./task-column.vue?vue&type=template&id=7d6fde49&scoped=true"
import script from "./task-column.vue?vue&type=script&lang=js"
export * from "./task-column.vue?vue&type=script&lang=js"
import style0 from "./task-column.vue?vue&type=style&index=0&id=7d6fde49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6fde49",
  null
  
)

export default component.exports